import { render, staticRenderFns } from "./TableRestrictionContentMinStay.vue?vue&type=template&id=577fa2ba&scoped=true&"
import script from "./TableRestrictionContentMinStay.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionContentMinStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fa2ba",
  null
  
)

export default component.exports